import { useState } from "react";
import { AnalysisPanelTabs } from "../../../components/AnalysisPanel";

/**
 * Custom hook for managing UI state
 */
export const useUIState = () => {
    const [activeCitation, setActiveCitation] = useState<string>();
    const [activeAnalysisPanelTab, setActiveAnalysisPanelTab] = useState<AnalysisPanelTabs | undefined>(undefined);
    const [selectedCitation, setSelectedCitation] = useState(0);
    const [warningShown, setWarningShown] = useState<boolean>(true);
    const [applyRestriction, setApplyRestriction] = useState<boolean>(false);
    const [showSupportLink, setShowSupportLink] = useState<boolean>(false);
    const [isSnackOpen, setIsSnackOpen] = useState(false);
    const [sessionStatus, setSessionStatus] = useState<string>(localStorage.getItem("disclaimerHide") ?? "initial");

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const [activateAnswerTour, setActivateAnswerTour] = useState<boolean>(false);

    return {
        activeCitation,
        setActiveCitation,
        activeAnalysisPanelTab,
        setActiveAnalysisPanelTab,
        selectedCitation,
        setSelectedCitation,
        warningShown,
        setWarningShown,
        applyRestriction,
        setApplyRestriction,
        showSupportLink,
        setShowSupportLink,
        isSnackOpen,
        setIsSnackOpen,
        sessionStatus,
        setSessionStatus,
        windowSize,
        setWindowSize,
        activateAnswerTour,
        setActivateAnswerTour
    };
};
